// extracted by mini-css-extract-plugin
export default {"unspacedLabel":"Select_unspacedLabel__XQteb","spacedLabel":"Select_spacedLabel__nuA-5"};